import StudiesLayoutMobile from './StudiesLayoutMobile';
import { isMobile } from '../../services/DeviceInformation';
import StudiesLayoutDesktop from './StudiesLayoutDesktop';

export default function Studies() {
    if (isMobile()) {
        return <StudiesLayoutMobile />;
    }
    return <StudiesLayoutDesktop />;
}
